import React, {useState, useEffect} from "react";


import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    LinearProgress,
    TextField,
    Theme,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MonitorIcon from '@mui/icons-material/Monitor';
import {ContainerClasses} from '../../themes/containerClasses'
import {useAuth} from "../../hooks/useAuth";
import {useSnackbar} from "notistack";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import {getPasswordScore} from "../../utils/fieldValidations";


export const PWDChangeDialog: React.FC<{
  username: string,
  password: string
}> = ({
  username,
  password
}) => {

  const styles = ContainerClasses();

  const {error, pwdChangeRequired, onPwdChange, accessToken, isLoading} = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const [otp, setOtp] = useState<string>("");
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
  const [showNewPasswordCheck, setShowNewPasswordCheck] = useState<boolean>(false);
  const [newPassword, setNewPassword] = useState<string>("");
  const [newPasswordCheck, setNewPasswordCheck] = useState<string>("");


  useEffect(() => {
    if(error.errorMfaChallenge !== ""){
         enqueueSnackbar(error.errorMfaChallenge, {
          variant: "error",
        });
      }
  }, [error]);

  const handleNewPasswordChange = (newPassword: string) => {
    setNewPassword(newPassword);
  }


  const onSubmitNewPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPwdChange(newPassword, accessToken)
  };

  const passwordStrength = getPasswordScore(newPassword)

  return (

    <Dialog
          open={pwdChangeRequired}
          onClose={() => {}}
          maxWidth={"lg"}
          fullWidth
          TransitionComponent={Slide}
          TransitionProps={{direction: "up"} as any}
    >

       <DialogTitle>
          {isLoading && <LinearProgress color="primary" />}
         <Box sx={{mt: '4pt',
                   mb: '4pt'}}>
           <Typography
               color="textSecondary"
               align="center"
             >
               Please change your password
             </Typography>
          </Box>
       </DialogTitle>

      <Box sx={{
        marginTop: "20px",
        marginLeft: "10px",
        marginRight: "10px",
        marginBottom: "10px"
      }}>

         <Typography>
           Please provide a strong password including:
         </Typography>

         <Typography component="ul">
           <li> At least one number or one special character such as: #, +, -, * </li>
           <li> At least one lower and one upper case letter</li>
           <li> Minimum 6 characters</li>
         </Typography>

         <Box sx={{mt: '8pt',
                   mb: '8pt'}}>

             <TextField
               size="small"
               label="New password"
               variant="filled"
               fullWidth
               type={showNewPassword ? "text" : "password"}
               InputProps={{
                 disableUnderline: true,
                 endAdornment: (
                     <InputAdornment position="end">
                         <IconButton size="small" onClick={() => setShowNewPassword(!showNewPassword)}>
                             {showNewPassword &&
                                 <VisibilityRoundedIcon/>
                             }
                             {!showNewPassword &&
                                 <VisibilityOffRoundedIcon/>
                             }
                         </IconButton>
                     </InputAdornment>
                 ),
               }}
               value={newPassword}
               onChange={(event) => handleNewPasswordChange(event.target.value)}
             />

             <Box>
                <Box sx={styles.containerRowB}>
                 <Box sx={{height: 5,
                           width: "25%",
                           mt: 1,
                           mr: 1,
                           borderRadius: 5,
                           backgroundColor: passwordStrength.score > 0 ? passwordStrength.backgroundColor : "transparent"}} />
                 <Box sx={{height: 5,
                           width: "25%",
                           mt: 1,
                           mr: 1,
                           borderRadius: 5,
                           backgroundColor: passwordStrength.score > 25 ? passwordStrength.backgroundColor : "transparent"}} />
                 <Box sx={{height: 5,
                           width: "25%",
                           mt: 1,
                           mr: 1,
                           borderRadius: 5,
                           backgroundColor: passwordStrength.score > 50 ? passwordStrength.backgroundColor : "transparent"}} />
                 <Box sx={{height: 5,
                           width: "25%",
                           mt: 1,
                           borderRadius: 5,
                           backgroundColor: passwordStrength.score > 75 ? passwordStrength.backgroundColor : "transparent"}} />
                </Box>
                <Typography>
                   {passwordStrength.text}
                </Typography>
            </Box>

         </Box>

         <Box sx={{mt: '8pt',
                   mb: '8pt'}}>


{/*         <Box sx={{mt: '4pt',
                   mb: '4pt'}}>
*/}
             <TextField
               size="small"
               label="Confirm new password"
               variant="filled"
               fullWidth
               type={showNewPasswordCheck ? "text" : "password"}
               InputProps={{
                 disableUnderline: true,
                 endAdornment: (
                     <InputAdornment position="end">
                         <IconButton size="small" onClick={() => setShowNewPasswordCheck(!showNewPasswordCheck)}>
                             {showNewPasswordCheck &&
                                 <VisibilityRoundedIcon/>
                             }
                             {!showNewPasswordCheck &&
                                 <VisibilityOffRoundedIcon/>
                             }
                         </IconButton>
                     </InputAdornment>
                 ),
               }}
               value={newPasswordCheck}
               onChange={(event) => setNewPasswordCheck(event.target.value)}
             />

         </Box>

         <Box sx={styles.containerRowB}>
         <Button
            color="primary"
            variant="contained"
            fullWidth
            disabled={isLoading || newPassword !== newPasswordCheck || passwordStrength.score < 75}
            onClick={(event) => onSubmitNewPassword(event)}
        >
           Set new password
        </Button>
      </Box>

    </Box>

  </Dialog>


  );

};
